export default {
   
  deforestation: {
    privacyEnabled:"Privacidad habilitada",
    geolocationPrivacySubHeading: "Interruptor para controlar la confidencialidad de los datos de ubicación. Actívalo para marcar la ubicación como confidencial y restringir su visibilidad. Desactívalo para hacer que la ubicación sea accesible públicamente.",
    geolocationPrivacy:"Privacidad de geolocalización",
    
    sendToOperator: "Enviar al operador",
    failedEudrReportDueSetting:'Por favor, asegúrese de que la configuración de las siguientes propiedades esté correctamente configurada: Vencimiento del Informe, Masa Neta, Volumen y Radio.',
    producerData:{
      addProducers:"Agregar Nuevo Productor",
      countryInfo: "Campo para ingresar o mostrar el país asociado con un productor."
    },
    uploadedToEU: "Subido al portal de la UE",
    pending: "Pendiente",
    underReview: "En revisión",
    compliant: "Cumple",
    nonCompliant: "No cumple",
    analyzeDeforestation: "Analizando deforestación",
    readyToProceed: "Listo para proceder",
    processingFarm: "Procesando granja",
    mitigationRequired: "Mitigación requerida",

    veryHighDeforestationProbability: "Probabilidad de deforestación muy alta",
    highDeforestationProbability: "Probabilidad de deforestación alta",
    mediumDeforestationProbability: "Probabilidad de deforestación media",
    lowDeforestationProbability: "Probabilidad de deforestación baja",
    veryLowDeforestationProbability: "Probabilidad de deforestación muy baja",
    zeroNegligibleDeforestationProbability: "Probabilidad de deforestación cero/negligible",
    manuallyMitigated: "Mitigado manualmente",

    selectCountry: "Seleccionar País",
    internalReferenceNumberMustBeAlphanumeric: "El número de referencia interna debe ser alfanumérico",
    atLeastOneOfSupplierIdOrSupplierNameIsRequired: "Se requiere al menos uno de los campos ID de proveedor o Nombre de proveedor",
    atLeastOneOfOperatorIdOrOperatorNameIsRequired: "Se requiere al menos uno de los campos ID de operador o Nombre de operador",
    netMassIsRequired: "Se requiere la masa neta",
    netMassMustBeValid: "La masa neta debe ser válida",
    thisFieldIsRequired: "Este campo es obligatorio",
    volumeMustBeNumeric: "El volumen debe ser numérico",
    nameIsRequired: "El nombre es obligatorio",
    firstNameIsRequired: "El nombre es obligatorio",
    lastNameIsRequired: "El apellido es obligatorio",
    countryIsRequired:"El país es obligatorio",

    confirmPdfDownload: "¿Desea descargar todos los archivos adjuntos en formato PDF?", 
    confirmJsonDownload:"¿Desea descargar todos los archivos adjuntos en formato JSON?",
    basicFinalFarmListWithStatus: "Lista de fincas finales básicas con estado",
    detailedInformationIncludingDescriptionOfRiskMitigationActivities: "Información detallada, incluida la descripción de las actividades de mitigación de riesgos",
    completeDocumentIncludingRiskMitigationAndAttachedDocuments: "Documento completo, incluida la mitigación de riesgos y los documentos adjuntos",
    
    existing: "Existente",
    survey: "Encuesta",

    operatorInformation: "Información del Operador", 
    addNewOperator: "Agregar un Nuevo Operador", 
    
    reportAddedSuccessfully: "Reporte agregado exitosamente",
    reportUpdatedSuccessfully: "Reporte actualizado exitosamente",
    itemDeletedSuccessfully : "Elemento eliminado exitosamente.",
    reportDeletedSuccessfully: "Reporte eliminado exitosamente",
    anErrorOccurredWhileDeletingTheReport : "Ocurrió un error al eliminar el reporte.",

    valueMustBeBetween02And40: "El valor debe estar entre 0.2 y 40",

    EUDRDeforestationStatusTT: "Selección del estado de deforestación. Alta Probabilidad de Deforestación: Una categoría específica de evaluación de riesgos asignada a determinadas áreas geográficas según su probabilidad de deforestación o degradación forestal. Ayuda a determinar los requisitos de diligencia debida para los operadores que colocan en el mercado de la UE productos básicos relevantes (como cacao, café, etc.) o productos que los contienen o se fabrican con ellos. Baja Probabilidad de Deforestación: Una categoría de evaluación de riesgos asignada a áreas geográficas que se consideran poco propensas a experimentar deforestación o degradación forestal significativa. Esta designación influye en los requisitos de diligencia debida para los operadores que colocan en el mercado de la UE productos básicos o productos procedentes de estas áreas. Probabilidad de Deforestación Nula/Insignificante: Una probabilidad muy baja o inexistente de que ocurra deforestación. Implica que el riesgo o impacto de la deforestación se considera extremadamente pequeño o insignificante.",
    
    complianceRiskWarnings: "Advertencias de Riesgo de Cumplimiento",
    complianceRiskWarningsInfo: "Muestra el título de la sección, indicando que esta área se centra en las advertencias relacionadas con los riesgos de cumplimiento en el proceso de diligencia debida.",
    locationVerificationTT: "Se refiere al proceso de confirmar y validar la ubicación geográfica de los sitios de producción como parte de los procedimientos de diligencia debida. Implica garantizar que los detalles de ubicación proporcionados, como coordenadas o dirección, representen con precisión la ubicación física donde ocurren las actividades de producción. Esta verificación es crucial para evaluar los impactos ambientales, el cumplimiento del uso de la tierra y la precisión de los datos informados dentro del informe de diligencia debida.", 
    netMassKg: "Masa Neta (kg)",
    volumeM3: "Volumen (m3)",
    volumeM: "Volumen",
    warning: "Advertencia",

    productionPlacesTT: "Ubicaciones donde se fabrican o cultivan bienes.",
    productionPlacesCountryInfo: "Un cuerpo territorial distinto con su propio gobierno y fronteras.",
    productionPlacesProducersInfo: "Entidad responsable de crear o cultivar bienes.",
    totalsTT: "La sección 'Totales' proporciona un resumen de los principales indicadores cuantitativos para todo el conjunto de datos o informe. Agrega datos para ofrecer a los usuarios una visión rápida de las métricas generales, como la masa total del producto, el volumen total del producto, el área del lugar de producción, etc., involucrados en el informe de diligencia debida.",

    AnalysisOfDeforestationStatusTT: "El análisis del estado actual de la deforestación dentro de un área específica, generalmente realizado para evaluar el impacto ambiental o el cumplimiento de los esfuerzos de conservación.",

    complete : "Completo",

    undoDelete: "Deshacer Eliminación",

    verifyingLocationsData: 'Verificando datos de ubicación(es)...',
    crossCheckingWithProductionPlaces: 'Verificando con los lugares de producción...',
    almostTherePleaseHoldOn: 'Casi allí, por favor espera...',
    LocationVerifiedSuccessfully: '¡Ubicación(es) verificadas con éxito!',
    allProductionPlacesAndLocationsHaveBeenConfirmed: '¡Todos los lugares de producción y ubicaciones han sido confirmados!',
    errorCheckingOverlaps: 'Error al verificar superposiciones.',
    farmIsBiggerThan4HectaresItNeedsToBeAPolygon: 'La granja es mayor de 4 hectáreas, necesita ser un polígono',
    failedToFetchSettings: 'No se pueden obtener las configuraciones. Por favor, revise sus configuraciones o contacte con soporte si el problema persiste.',
    farmCountryNotDefined: 'País de la granja no definido.',
    theGeofencesSupposeToBeIn: 'La geocerca se supone que está en',
    butItsIn: 'pero está en',
    geofenceIsInOcean: 'La geocerca o parte de ella está en el océano.',

    existingReport: "Informe de Deforestación Existente",
    dimitraReport: "Informe de Deforestación de Dimitra",

    attachRiskMigrationDocTT: "Indica la acción de asociar o vincular un único documento a todas las fincas identificadas con riesgo de deforestación, generalmente con fines de documentación o cumplimiento normativo.",    
    oneForAllFarms:"Uno para Todas las Fincas",
    oneForEachFarm:"Uno para Cada Finca",
    uploadExistingAssessment:"Subir Evaluación Existente",
    completeDimitraAssessment:"Evaluación por Operador o Proveedor",
    assessmentByFarmer: "Evaluación por el Agricultor",
    approve: "Aprobar",
    conclude: "Concluir",
    approveMessage: "¿Está seguro de que desea aprobar este informe? Al aprobar este informe, se subirá permanentemente a la blockchain. Se generará un enlace de blockchain y un código QR, y no se podrán hacer más actualizaciones o ediciones. ¿Desea continuar?",
    disputeReason: "Motivo de la disputa",
    disputeStatus: "Estado de la disputa",
    disputeArea: "Tamaño del área",
    selectDefaultMeasurementUnit:
      "Seleccionar Unidades de Medida Predeterminadas",
    selectDefaultMeasurementUnitInfo: "Permite la selección de las unidades predeterminadas de medición, incluyendo especificar la unidad, establecer un límite máximo y marcarla como la opción predeterminada.",
    maxLimit: "Límite Máximo",
    maxLimitInfo: "Establece el valor o umbral máximo permitido para un parámetro en particular.",
    asDefault: "Marcar como Predeterminado",
    productMass: "Masa del Producto",
    productMassUnitInfo: "Especifica la unidad para medir la masa de un producto.",
    volumeUnitInfo: "Especifica la unidad para medir el volumen de un producto.",
    operatorInfo: "Se refiere a un individuo o entidad responsable de gestionar o operar un sistema o proceso.",
    supplierInfo: "Una entidad que proporciona bienes o servicios a otra entidad.",
    userTypeInfo: "Clasifica a individuos o entidades según su rol o permisos dentro del sistema.",
    unit: "Unidad",
    userType: "Tipo de Usuario",
    eudrPortalApiKeys: "Claves API del Portal EUDR",
    apiKey: "Clave API",
    apiSecret: "Secreto API",
    headingCreatedSuccessfully: "Creado con éxito",
    headingOrderSuccessfullyUpdated: "Pedido actualizado con éxito",
    headingUpdatedSuccessfully: "Actualizado con éxito",
    questionTypeNotDefined: "Tipo de pregunta no definido",
    assessmentRiskMitigationLvl:
      "Niveles de Mitigación del Riesgo de Evaluación",
    assessmentRiskMitigationLvlInfo: "Categoriza la gravedad de los riesgos asociados con el uso de la tierra, las prácticas forestales y la expansión agrícola. Estos niveles ayudan a identificar el impacto potencial de las actividades en las áreas boscosas y guían las acciones adecuadas para mitigar las consecuencias negativas. Categoriza los niveles de las estrategias de mitigación de riesgos, incluyendo muy alto, alto, medio, bajo y cero/insignificante.",

    dynamicExpiryTime: "Periodo de Expiración Dinámico",
    dynamicExpiryTimeInfo: "Establece un período de tiempo después del cual ciertos datos o configuraciones caducan automáticamente. Configura ajustes relacionados con los informes de deforestación, incluyendo opciones para la renovación automática.",
    eudrDeforestationAssessment: "Evaluación de la Deforestación EUDR",
    autoRenewalIf:
      "Renovación Automática al Añadir al Informe de Diligencia Debida",
    declarationStatements: "Declaraciones",
    declarationStatementsInfo: "Declaraciones realizadas por la parte responsable certificando la exactitud, integridad y autenticidad de la información contenida en el informe.",
    filterDeclaration: "Filtrar Declaraciones",
    declarationTitle: "Título de la Declaración",
    declarationTitleInfo: "Título o encabezado para una declaración, proporcionando contexto o resumiendo su contenido.",
    applicableCountry: "Países Aplicables",
    applicableCountryInfo: "Lista de los países a los que se aplican ciertos ajustes o regulaciones.",
    addMore: "Añadir Más",
    autoRenewal: "Renovación automática",
    createNewAssessment: "Crear nueva evaluación",
    userDimitraAssessment: "Usar Evaluaciones de Dimitra",
    eudrComplianceStatus: "Utilice las evaluaciones de Dimitra",
    shipmentList: "Lista de Envíos",
    generalData: "Datos Generales",
    check: "Controlar",
    deforestationComplianceReport: "Informes de Cumplimiento de Deforestación",
    noDeforestationComplianceReport:
      "No se Encontró Informe de Cumplimiento de Deforestación",
    loadingDeforestationComplianceReport:
      "Cargando Informe de Cumplimiento de Deforestación",
    farmName: "Nombre de la Finca",
    farmRegistrationId: "ID de Registro de la Finca",
    farmerName: "Nombre del Agricultor",
    farmerRegistrationId: "ID de Registro del Agricultor",
    uniqueFarmerId: "ID Único del Agricultor",
    uniqueFarmId: "ID Único de la Finca",
    farmLocation: "Ubicación de la Finca",
    area: "Área",
    farmAddress: "Dirección de la Finca",
    dateOfRequest: "Fecha de Solicitud",
    status: "Estado",
    settings: "Configuraciones",

    farmLatitude: "Latitud de la Finca",
    farmLongitude: "Longitud de la Finca",
    shareQRCode: "Compartir Código QR",
    copy: "Copiar",

    allCountries: "Todos los Países",
    allRegions: "Todas las Regiones",
    allFarms: "Todas las Fincas",
    allProducer:"Todos los productores",
    viewCertificate: "Ver Certificado",

    assignmentIssued: "Asignación Emitida",

    complianceCertification: "Certificación de Cumplimiento",
    noComplianceCertification: "No se Encontró Certificación de Cumplimiento",
    loadingComplianceCertification: "Cargando Certificación de Cumplimiento",

    eudrForestAssessment: "Evaluaciones Forestales EUDR",
    assessmentReport: "Informe de Evaluación",
    downloadPDF: "Descargar PDF",
    back: "Atrás",
    farmDetails: "Detalles de la Finca",

    dimitraFarmId: "ID de Finca Dimitra",
    dimitraFermerId: "ID de Agricultor Dimitra",

    totalGeofenceAreaHA: "Área Total de Geovalla (AC)",
    forestLossHA: "Pérdida de Bosque (AC)",
    forestGainHA: "Ganancia de Bosque (AC)",
    forestUnchangedHA: "Bosque Sin Cambios (AC)",
    shareCertificate: "Compartir Certificado",
    forestUnchanged: "Bosque Sin Cambios",
    forestLoss: "Pérdida de Bosque",
    forestGain: "Ganancia de Bosque",
    totalGeofenceArea: "Área Total de Geovalla",
    deforestationProbability: "Probabilidad de Deforestación",
    colorCode: "Código de Color",
    geofenceArea: "Área de Geovalla",
    percentageOfGeofenceArea: "Porcentaje del Área de Geovalla",
    view: "Ver",
    customization: "Personalización",
    recordsPerpage: "Registros por Página",
    restoreDefault: "Restaurar Valores Predeterminados",
    apply: "Aplicar",
    forestAssessmentHelp:
      "Si tiene preguntas sobre este informe o necesita ayuda para entenderlo, contáctenos a través del Servicio de Ayuda.",
    overallDeforestationProbability: "Probabilidad General de Deforestación",
    zeroOrNegligible: "Cero/Insignificante",
    high: "Alta",
    allStatus: "Todos los Estados",
    low: "Baja",
    veryHigh: "Muy Alta",
    medium: "Medio",
    veryLow: "Muy Baja",
    assessmentIssued: "Evaluación Emitida",
    certificateIssued: "Certificado Emitido",
    assessmentNo: "Número de Evaluación",
    blockchainCertificateDesc:
      "El Hash de Validación del Certificado Blockchain Estará Disponible Tras la Aceptación del Certificado",
    blockchainValidation: "Validación del Certificado Blockchain",
    openBlockchainPage: "Abrir Página Blockchain",
    clickLinkDesc:
      "Haga clic en el enlace de arriba para validar el certificado en la blockchain",
    tooltip: {
      dimitraFarmId:
        "Identificador único asociado con una Finca específica en el sistema Dimitra.",
      farmName: "El nombre designado de la finca.",
      farmRegistrationId: "Número de registro de la finca.",
      farmLocation:
        "Coordenadas geográficas específicas o ubicación de la finca.",
      dimitraFermerId:
        "Un identificador distinto vinculado a un agricultor individual dentro del sistema Dimitra.",
      farmerName: "Identificación de la persona responsable de la finca.",
      farmerRegistrationId: "Número de registro del agricultor.",
      assessmentNo: "Número único asignado a la evaluación.",
    },
    red: "Rojo",
    Yellow: "Amarillo",
    transparent: "Transparente",
    darkRed: "Rojo Oscuro",
    brightRed: "Rojo Brillante",
    orange: "Naranja",
    lightBlue: "Azul Claro",
    teal: "Verde azulado",
    zeroOrNegligibleProbability:
      "Probabilidad de Deforestación Cero/Insignificante",
    veryLowProbability: "Probabilidad de Deforestación Muy Baja",
    lowProbability: "Probabilidad de Deforestación Baja",
    mediumProbability: "Probabilidad de Deforestación Media",
    highProbability: "Probabilidad de Deforestación Alta",
    veryHighProbability: "Probabilidad de Deforestación Muy Alta",
    zeroOrNeglegible: "Cero o Negligible",
    zeroorneglegible: "Cero o Negligible",
    High: "Alta",
    Low: "Baja",
    "Zero/Negligible": "Cero/Insignificante",
    "Zero/Negligible Deforestation Probability":
      "Probabilidad de deforestación cero/insignificante",
    "Zero Deforestation Probability": "Probabilidad de deforestación cero",
    "Very Low Deforestation Probability":
      "Muy baja probabilidad de deforestación",
    "Low Deforestation Probability": "Baja probabilidad de deforestación",
    "Medium Deforestation Probability": "Probabilidad media de deforestación",
    "High Deforestation Probability": "Alta probabilidad de deforestación",
    "Very High Deforestation Probability":
      "Muy alta probabilidad de deforestación",
    zeroOrNeglegibleProbability:
      "Probabilidad de Deforestación Cero/Despreciable",
    very_high: "Muy Alto",
    very_low: "Muy Bajo",
    Orange: "Naranja",
    locationName: "Nombre de la ubicación",
    dueDeligence: "Debida Diligencia",
    supplierInformation: "Información del Proveedor",
    addNewSupplier: "Agregar un Nuevo Proveedor",
    name: "Nombre",
    lastName: "Apellido",
    email: "Correo Electrónico",
    phoneNumber: "Número de Teléfono",
    enterSupplierName: "Ingresar Nombre del Proveedor",
    enterSupplierLastName: "Ingresar Apellido del Proveedor",
    enterSupplierFirstName: "Ingresar Nombre del Proveedor",
    enterOperatorName: "Ingresar Nombre del Operador",
    enterEmailAddress: "Ingresar Dirección de Correo Electrónico",
    enterPhoneNumber: "Ingresar Número de Teléfono",
    whoWillAddPlace: "¿Quién Agregará los Datos del Lugar de Producción?",
    companyId: "ID de la Empresa",
    disputeId: "ID de disputa",
    activity: "Actividad",
    placeOfActivity: "Lugar de la Actividad",
    countryOfActivity: "País de la Actividad",
    operatorPlaceOfActivity: "Lugar de Actividad del Operador",
    operatorCountryOfActivity: "País de Actividad del Operador",
    countryOfEntry: "País de Entrada",
    productDetail: "Detalles del Producto",
    subProduct: "Sub-Producto",
    productionDescription: "Descripción del Producto",
    netMass: "Masa Neta",
    volume: "Volumen",
    scietificName: "Nombre Científico",
    commonName: "Nombre Común",
    eudrDueDeligenceReports: "Informes de Debida Diligencia EUDR",
    EUDRAssessmentReport: "Informe de Evaluación EUDR",
    createNewReport: "Crear Nuevo Informe",
    eudrRefNo: "No. de Referencia EUDR",
    eudrRefNoInfo: "Funcionalidad para encontrar información específica relacionada con el envío.",
    statusInfo: "El estado actual del envío en relación con el informe de debida diligencia.",
    eudrAndInternalRefNo: "No. de Referencia EUDR / Interna",
    exporterAndSupplier: "Exportador y Proveedor",
    internalRefNo: "No. de Referencia Interna",
    supplier: "Proveedor",
    quantity: "Cantidad",
    product: "Producto",
    noOfFarms: "Número de Granjas",
    farmsAndQuantity: "Granjas y Cantidad",
    country: "País",
    lastUpdated: "Última Actualización",
    dueDeligenceStatus: "Estado de la Debida Diligencia",
    edurDueDeligenceStatus: "Estado de la Debida Diligencia EUDR",
    reject: "Rechazar",
    discard: "Descartar",
    saveAndContinueLater: "Guardar y continuar más tarde",
    requestAdditionalInformation: "Solicitar información adicional",
    requestAdditionalInformationShort: "Solicitar más información",
    uploadToEudr: "Subir a EUDR",
    productionPlaces: "Lugares de Producción",
    next: "Siguiente",
    dueDeligenceReportCreation: "Creación de Informe de Debida Diligencia",
    producer: "Productor",
    select: "Seleccionar",
    productionPlacesFarmAndFarmId:
      "Lugar de producción (Finca) y ID de la granja",
    producerName: "Nombre del Productor",
    addressOfProduction: "Dirección de Producción",
    type: "Tipo",
    geofence: "Geovalla",
    areaHa: "Área (ha)",
    editGeofence: "Editar Geovalla",
    totals: "Totales",
    locationVerification: "Verificación de Ubicación",
    AnalysisOfDeforestationStatus: "Análisis del Estado de Deforestación",
    EUDRDeforestationStatus: "Estado de Deforestación EUDR",
    removeAllLowRiskFarm: "Eliminar todas las granjas de bajo riesgo",
    removeAllHighRiskFarm: "Eliminar todas las granjas de alto riesgo",
    attachRiskMigrationDoc:
      "Adjunte un documento de mitigación de riesgos para todas las granjas de alto riesgo",
    removedFarms: "Granjas eliminadas de la lista",
    generateCertificate: "Generar Certificado",
    viewDisputeHistory: "Ver Historial de Disputas",
    disputeAssessment: "Evaluación de Disputas",

    reportDetails: "Detalles del Informe",
    productionPlace: "Lugar de Producción",
    regionalRiskAssessment: "Evaluación de Riesgo Regional",
    EUDRDeforestationAssessment: "Evaluación de Deforestación EUDR",
    EUDRcountry: "El país donde se encuentra la explotación, vinculado al producto en el informe de diligencia debida. Ayuda a garantizar la trazabilidad geográfica tal y como exige la normativa EUDR.",
    riskAssessment: "Evaluación de Riesgos",
    legalInformation: "Información Legal",
    finalReport: "Informe Final",
    editGeolocation: "Editar Geolocalización",
    producerCountry: "País del Productor",
    manuallyAddData: "Agregar Datos Manualmente",
    drawGeofence: "Dibujar Geovalla",
    uploadFile: "Subir Archivo",
    typeyourlocation: "Escribe el nombre/dirección de tu ubicación",
    numberOfPoints: "Número de Puntos del Polígono",
    viewGeolocation: "Ver Geolocalización",
    geoLocation: "Geolocalización",
    Point: "Punto",
    Circular: "Circular",
    Polygon: "Polígono",
    selectFileToUpload: "Seleccione el archivo para cargar los datos",
    selectFileToUploadData: "Selecciona un archivo para cargar datos",
    submissionDate: "Fecha de Envío",
    eudrReferenceNo: "Nº de Referencia EUDR",
    internalReferenceNo: "Nº de Referencia Interna",
    exporter: "Exportador",
    exporterInfo: "Nombre del exportador. La entidad o parte responsable de exportar los bienes.",
    importer: "Importador",
    importerInfo: "Nombre del importador. La entidad o parte responsable de importar los bienes.",
    shipmentReferenceNo: "Nº de Referencia del Envío",
    shipmentReferenceNoInfo: "Un identificador único utilizado para referenciar el envío.",
    ownerShipType: "Tipo de Propiedad",
    ownerShipTypeInfo: "El tipo de propiedad asociada con el envío.",
    buyer: "Comprador",
    buyerName: "Nombre del comprador",
    port_of_origin: "Puerto de Origen",
    port_of_origin_info: "La ubicación donde se origina el envío.",
    port_of_destination: "Puerto de Destino",
    port_of_destination_info: "El puerto de destino previsto para el envío.",
    no_of_stops: "Nº de Paradas",
    shipping_line: "Línea de Navegación",
    shipping_line_info: "La empresa o entidad responsable de transportar el envío.",
    expected_arrival_date: "Fecha de Llegada Estimada",
    expected_arrival_date_info: "Fecha anticipada de llegada del envío a su destino.",
    container_id: "ID del Contenedor",
    container_id_info: "Identificador único para el contenedor de envío utilizado en el envío.",
    container_type: "Tipo de Contenedor",
    container_type_info: "El tipo o categoría de contenedor de envío.",
    container_size: "Tamaño del Contenedor (ft)",
    container_size_info: "Las dimensiones físicas del contenedor de envío.",
    container_capacity: "Capacidad del Contenedor (Toneladas)",
    container_capacity_info: "La carga máxima o capacidad del contenedor de envío.",
    eudr_reference_number: "Número de Referencia EUDR",

    select_default_measurement_units:
      "Seleccionar Unidades de Medida Predeterminadas",
    radius: "Radio",
    maximum_limit: "Límite Máximo",
    product_mass: "Masa del Producto",
    user_type: "Tipo de Usuario",
    eudr_api_keys: "Claves de API del Portal EUDR",
    api_key: "Clave de API",
    api_secret: "Secreto de API",
    assessment_risk_mitigation_levels:
      "Niveles de Mitigación de Riesgos de la Evaluación",
    dynamic_expiry_time_period: "Período de Expiración Dinámica",
    eudr_deforestation_assessment: "Evaluación de Deforestación EUDR",
    auto_renewal: "Renovación Automática",
    auto_renewal_when_added_to_the_due_diligence_report:
      "Renovación Automática Cuando se Añade al Informe de Diligencia Debida",
    declaration_statements: "Declaraciones",
    filter_declaration_statements: "Filtrar Declaraciones",
    showing_all: "Mostrando Todo",
    declaration_title: "Título de la Declaración",
    applicable_countries: "Países Aplicables",
    enabled: "Habilitado",
    disabled: "Deshabilitado",
    add_more: "Añadir Más",
    mark_as_default: "Marcar como Predeterminado",
    locationVerificationTab:{
      confirmationTitle: "Confirmación",
      confirmationMessage: "Está a punto de editar los datos de geolocalización de esta explotación. Tenga en cuenta que cualquier cambio en la geolocalización requerirá una nueva verificación de todos los pasos relacionados, incluida la verificación de la ubicación, el análisis de la deforestación y la evaluación del riesgo regional (comprobaciones de zonas protegidas e indígenas). Los cambios en el nombre de la explotación o del agricultor no requerirán una nueva verificación. ¿Desea continuar?",
    },
    locationModified: {
      headerTitle: "Ubicaciones Modificadas",
      headerDescription: "Hemos detectado que las siguientes ubicaciones han sido modificadas y necesitan ser verificadas nuevamente.",
    },
    processingDialog: {
      modalHeader: "Analizando el Estado de la Deforestación",
      modalDescription_first: "Analizando el Estado de la Deforestación EUDR",
      modalDescription_second: "Tus granjas están siendo sometidas a un Análisis Automatizado de Deforestación. Serás redirigido a la página de la lista de Informes de Diligencia Debida para ver el estado.",
    },
    farmList: {
      title: "Listado de granjas EUDR",
      addFarmGeofenceManually: "Agregar geocerca de granja manualmente",
      importGeofenceInBulk: "IMPORTAR GEO-CERCAS EN MASA",
      searchPlaceHolder: "Buscar por nombre de agricultor",
      generateCertificate: "Generar certificado",
      requestAssementReport: "Solicitar informe de evaluación",
      producer: "Productor",
      farmNameAndId: "Nombre y ID de la granja",
      addressOfProduction: "Dirección de producción",
      registrationDate: "Fecha de registro",
      eudrDeforestationStatus: "Estado de deforestación EUDR",
      riskAssessmentStatus: "Estado de evaluación de riesgos",
      assessmentTitle: "Título de la evaluación",
      assessmentDescription: "Descripción de la evaluación",
      submissionDate: "Fecha de envío",
      expiryDate: "Fecha de expiración",
      assessmentStatus: "Estado de la evaluación",
      downloadAsKmx: "Descargar como KMX",
      downloadAsKml: "Descargar como KML",
      downloadAsShp: "Descargar como SHP",
      downloadAsCsv: "Descargar como CSV",
      downloadAsExcel: "Descargar como EXCEL",
      downloadAsPdf: "Descargar como PDF",
      downloadAsGeoJson: "Descargar como GeoJSON",
      loadingFarms: "Cargando granjas",
    },
    dueDeligenceReport:
      "Configuración del Informe de Diligencia Debida Pública",
    allowPublicDownload:
      "Permitir la descarga pública de geocercas de granjas en formato GeoJson",
    showDeforestationSummary:
      "Mostrar resumen de riesgo de deforestación EUDR por categoría",
    cancel: "Cancelar",
    createShipment: "Crear Envío",
    actions: "Acciones",
    operator: "Operador",
    download: "Descargar",
    print: "Imprimir",
    loading: "Cargando...",

    deforestationAssessmentRiskToleranceLevel:
      "Nivel de Tolerancia al Riesgo de Evaluación de Deforestación",
    deforestationAssessmentRiskToleranceLevelInfo:
      "Utilice esta herramienta para configurar qué % de deforestación, para cada calificación, es aceptable dentro de su proceso de Evaluación de Riesgos. Las granjas con un riesgo menor o igual al definido se considerarán aptas para permanecer en el DDS, sin necesidad de llevar a cabo la Mitigación de Riesgos.",
      tons: "Toneladas",

      failedToDeleteQuestion: "Error al eliminar la pregunta",
      questionOrderSuccessfullyUpdated: "Orden de preguntas actualizado con éxito",
      assessmentUpdatedSuccessfully: "Evaluación actualizada con éxito",
      pleaseWaitCurrentlyUpdatingChecklist: "Por favor espere, actualizando lista de verificación",
     
      riskMitigation: "Mitigación de Riesgos",
      riskMitigationHistory: "Historial de Mitigación de Riesgos",
      signParticipationSurvey : "¿Podría firmar digitalmente para confirmar su participación en esta encuesta?",
      signedBy: "Firmado digitalmente por:",
      assessmentRiskMitigation: "Mitigación de Riesgos de Evaluación",
      assessmentDetails: "Detalles de la evaluación",
      dontShowWarning: "No vuelvas a mostrar esta advertencia.",
      dateSubmitted: "Fecha de envío",
      addAComment: "Añadir un comentario",
      changeAssignee: "Cambiar asignado",
      changeStatus: "Cambiar estado",
      assignedUser: "Usuario asignado",
      selectAssignee: "Seleccionar asignado",
      reply: "Responder",
      discussion: "Discusión",
      attachment: "Adjunto",
      sizeKb: "Tamaño (KB)",
      dateAdded: "Fecha añadida",
      
      loadingProductionPlaces: "Cargando lugares de producción",
      shipmentStatus:"Estado del Envío",
      viewStops:"Ver Paradas",
      enRoute:"En Camino",
      delivered:"Entregado",
      failed:"Fallado",
      removeEudrDeforestationStatus: "Eliminar Estado de Deforestación EUDR",
      riskAssessmentStatusIsRequired: "El estado de evaluación de riesgos es obligatorio",
      requestAdditionalInformationPage: {
        descriptionLabel: "Proporcione comentarios o instrucciones específicas en el cuadro de texto a continuación. Una vez enviado, se notificará al proveedor y se le otorgará acceso para editar el informe de diligencia debida. Se le notificará cuando el proveedor actualice el informe.",
        shareAccessLabel: "El proveedor actualmente no tiene acceso a este informe. ¿Le gustaría compartir el acceso con el proveedor? Por favor, elija cómo le gustaría compartir el acceso:",
        shareCompleteReportLabel: "Compartir informe completo",
        shareSpecificStepLabel: "Compartir paso específico"
      },
      issueFound: "Problema encontrado",
      complianceRiskWarningsTT: "Las notificaciones de advertencia de riesgos le alertan sobre posibles problemas de cumplimiento en cada paso del proceso de diligencia debida. Estas notificaciones ayudan a garantizar que se identifiquen todos los riesgos antes de proceder a la siguiente etapa. Puede habilitar o deshabilitar estas alertas en cualquier momento en la Configuración del Informe o durante la creación del informe.",
      eudrVerificationNo:"Número de verificación",
      eudrVerificationNoTT:"Número de verificación recibido de EUDR",
      statusLegend: "Leyenda de Estado",
      statusLegendInfo: "La leyenda de estado proporciona una visión general rápida del estado actual del informe de diligencia debida. Se utiliza para indicar el estado actual del informe y las acciones que se pueden tomar para actualizarlo.",
      sentToExporter: "Enviado al Exportador",
      approved: "Aprobado",
      updateRequired: "Actualización Requerida",
      rejected: "Rechazado",
      noExporterFound: "No se encontró exportador",
      exporterFoundSuccessfully: "Exportador encontrado con éxito",
      enterExporterEmail: "Ingrese el correo electrónico del exportador",
      shareReport: "Compartir informe",
      exporterInformation: "Información del exportador",
      pleaseEnterExporterEmail: "Por favor, ingrese el correo electrónico del exportador",
    
  },


  containerTypes: {
    standardDry: "Contenedor Seco Estándar (20ft, 40ft)",
    highCube: "Contenedor de Cubo Alto",
    openTop: "Contenedor Abierto",
    flatRack: "Contenedor de Bastidor Plano",
    refrigerated: "Contenedor Refrigerado (Reefer)",
    tank: "Contenedor de Tanque",
    ventilated: "Contenedor Ventilado",
    insulated: "Contenedor Aislado",
    platform: "Contenedor de Plataforma",
    halfHeight: "Contenedor de Media Altura",
    bulk: "Contenedor a Granel"
  },

  dueDiligence: {
    comments: "Comentarios",
    "commentsRegardingStatement": "Comentarios sobre la declaración",
    enableRiskWarnings: "Habilitar advertencias de riesgo en pantalla",
    doYouWantToSendToOperator: "¿Quieres enviar este informe al operador?",
    countryOfProduction: "País de Producción",
    countryOfProductionTT: "País de Producción",
    containerId:"Id. de contenedor",
    createWithoutRiskAssessment: {
      title: "Crear DDS sin evaluación de riesgos",
      message: "¿Desea crear un DDS sin agregar una evaluación de riesgos? Si es así, las reglas de verificación de quejas omitirán este paso.",
      confirmBtnText: "Sí",
      cancelBtnText: "No"
    },
    noAssessmentWarning: "Falta las evaluaciones de riesgo en el informe DDS.",
    disputeReason: "Por favor, elija un motivo de disputa.",
    agricultureAgreement: "Por favor, acepte el término antes de continuar.",
    attachDisputeFile: "Por favor, adjunte un archivo antes de presentar la disputa.",
    listOfFarmsInfo:"Una visualización completa de las fincas, que incluye información como la ubicación de producción, el nombre del productor, el país de operación, el área de tierra en hectáreas, el tipo de actividades agrícolas, evaluaciones relacionadas con la deforestación y evaluaciones de riesgos potenciales asociados con las operaciones agrícolas",
    producerTT: "Selección de productores o fabricantes involucrados en la cadena de suministro.",  
    supplierInformationTT: "Detalles sobre la entidad que proporciona bienes o servicios.",
    operatorTooltip: "Seleccione el operador de la lista pre-registrada en el sistema",
    operatorSelect: "Operador: Elija esta opción si usted, como operador, será responsable de agregar datos de lugar de producción. Tendrá la opción de proporcionar una lista de productores, sus granjas y las geolocalizaciones dentro de la aplicación.",  
    supplierSelect: "Proveedor: Elija esta opción si el proveedor será responsable de agregar datos de lugar de producción. Tendrán acceso para proporcionar la lista de productores, sus granjas y las geolocalizaciones directamente dentro de la aplicación.", 
    selectWhoWillAddPlaceData: "Seleccione quién agregará los datos del lugar de producción",
    supplierTooltip: "Seleccione el proveedor de la lista pre-registrada en el sistema.",
    requiredAssessmentTooltip: "Elegir información de evaluación necesaria.",
    internalRefNoTooltip: "Un identificador único asignado dentro de una organización o sistema para hacer referencia a datos, transacciones o registros específicos con fines de seguimiento y gestión internos.", 
    eudrRefNoTooltip: "Se refiere a un identificador único asociado con el Reglamento de Deforestación de la Unión Europea (EUDR), generalmente utilizado para rastrear y hacer referencia a información relacionada con el cumplimiento en el contexto de las regulaciones de deforestación.",  
    companyIdTooltip: "Un identificador distinto asignado a una empresa u organización con fines de identificación y seguimiento, a menudo utilizado dentro de sistemas, bases de datos o marcos regulatorios.", 
    placeOfActivityTooltip:"Especifique el país del operador donde se realizan las actividades y el país donde el producto ingresará al mercado de la UE. Estos detalles son esenciales para el cumplimiento preciso de los requisitos de EUDR.",  
    productDetailToolTip:"Proporciona información detallada sobre el producto, incluido su nombre, masa neta, volumen, nombre científico y nombre común.",
    productToolTip: "Nombre del producto. Se refiere a un artículo o mercancía tangible producido, fabricado o comercializado por una empresa",
    productDescToolTip: "Proporciona una explicación o resumen textual de las características, funciones o atributos de un producto, con el objetivo de informar a los usuarios o clientes sobre su naturaleza o funcionalidad.",  
    subProductToolTip: "Nombre del Sub - Producto. Denota una categoría o subconjunto específico de una categoría de producto más grande, generalmente utilizado para una clasificación o diferenciación adicional dentro de una jerarquía de productos.", 
    netMassTooltTip: "Indica el peso de un producto o artículo, generalmente excluyendo el peso del embalaje u otros materia",
    volumeToolTip: "Se refiere a la cantidad de espacio ocupado por un producto o sustancia, generalmente medido en unidades cúbicas como metros cúbicos o pies cúbicos, utilizado para cuantificar la capacidad o cantidad en el espacio tridimensional.",  
    scietificNameToolTip: "Nombre taxonómico de un organismo que consta del género y la especie, por ejemplo, Coffea Arabica, Theobroma cacao L.", 
    commonNameToolTip: "Un nombre que se basa en el lenguaje normal de la vida cotidiana, por ejemplo, Cacao, Café.",
    manaulProductionPlaceTooltip: "Proceso de ingreso manual de ubicaciones de fabricación en el sistema.",
    producerNameTT: "El nombre de un individuo / empresa / organización que crea y suministra bienes o servicios",
    producerCountryTT: "La nación de origen de donde proviene el productor",
  
    productionPlaceUsingLots:'Seleccionar Lugares de Producción utilizando Lotes',
    dueDiligence: "Debida Diligencia EUDR",
    assementBuilder: "Constructor de Evaluaciones",
    assessment: "Evaluación",
    assessmentsList: "Lista de Evaluaciones",
    createAssessment: "Crear Evaluación",
    assessmentName: "Nombre de la Evaluación",
    assessmentNameInfo: "Funcionalidad para encontrar evaluaciones o información específica.",
    searchAssessment: "Buscar Evaluación",
    selectProcess: "Seleccionar Proceso de Evaluación",
    assessSettings: "Configuración de Evaluación",
    assessmentTitle: "Título de la Evaluación",
    assessmentTitleInfo: "Nombre que identifica una evaluación.",
    assessDescription: "Descripción de la Evaluación",
    assessDescriptionInfo: "Breve explicación del propósito o contenido de la evaluación.",
    describeAsessment: "Describir la Evaluación",
    selectCountry: "Seleccionar País",
    expiryTime: "Tiempo de Expiración",
    expiryTimeInfo: "Duración hasta que la evaluación caduque o se vuelva inválida.",
    noQuestionEachStep: "Número de preguntas",
    byHeadings: "Por Encabezados",
    assessmentStatus: "Estado de la Evaluación",
    multiStepAssess: "Evaluación de Múltiples Pasos",
    allowAssessment: "Permitir que la evaluación sea respondida más de una vez",
    onlyIfExpired: "Solo si está Expirada",
    atAnyTime: "En Cualquier Momento",
    editAssessmentDetails: "Editar Pregunta de Evaluación",
    assessmentDetail: "Detalles de la Evaluación",
    addQuestion: "Agregar Pregunta de Evaluación",
    attachFiles: "Adjuntar Archivos",
    digitalSignature: "Firma Digital",
    showChecklist: "Mostrar Lista de Verificación",
    hideChecklist: "Ocultar Lista de Verificación",
    fileType: "Tipo de Archivo",
    allowMultipleFile: "Permitir Múltiples Adjuntos",
    allowComment: "Permitir Comentarios",
    uploadSignatureFile: "Cargar Archivo de Firma",
    drawSignature: "Dibujar Firma",
    addSubHeading: "Agregar Sub-Encabezado",
    editSubHeading: "Editar subtítulo",
    heading: "Encabezado",
    headingInfo: "Encabezado bajo el cual se categorizará la pregunta de la evaluación. Un menú desplegable para seleccionar el encabezado.",
    headingTitle: "Título del encabezado",
    subHeading: "Sub-Encabezado",
    dueDiligenceReports: "Informes de Debida Diligencia",
    logistics: "Logística",
    partOfOrigin: "Parte de Origen",
    destination: "Parte de Destino",
    addStop: "Añadir una detener",
    stop: "detener",
    enterStop: "Ingresar detener",
    manageFarms: "Gestionar Granjas",
    disputeResolution: "Resolución de Disputas",
    suppliers: "Proveedores",
    shipments: "Envíos",
    dueDiligenceGuide: "Guía de Debida Diligencia",

    // Activity Log translations
    activityLog: "Registro de actividad",
    activityLogTT: "Registro de acciones realizadas en este informe.",
    user: "Usuario",
    userRole: "Rol del usuario",
    ipAddress: "Dirección IP",
    segment: "Segmento",
    activityDescription: "Descripción de la actividad",

    selectRequiredAssessment: "Seleccionar Evaluaciones Requeridas",
    filterAssessments: "Filtrar Evaluaciones",
    dueDiligenceReportCreation: "Creación de Informes de Debida Diligencia",
    dueDiligenceNew: "Debida Diligencia",

    createNewReport: "Crear Nuevo Informe",
    operator: "Operador",
    supplier: "Proveedor",
    addMoreAssessments: "Agregar Más Evaluaciones",
    internalReferenceNumber: "Número de Referencia Interno",
    referenceNumber: "Número de Referencia",
    domestic: "Doméstico",
    import: "Importación",
    export: "Exportación",
    selectProduct: "Seleccionar Producto",
    selectSubProduct: "Seleccionar Sub Producto",
    addnewSupplier: "Agregar Nuevo Proveedor",
    farmDeforestationReport: "Informe de Deforestación de la Finca",

    addProductionPlaceData: "Agregar Datos del Lugar de Producción",
    addProductionPlaceDataTooltip: "Elige cómo deseas agregar datos",
    addProductionPlaceDataDesc:
      "Crea tus informes integrando datos de producción de diversas fuentes. Selecciona una o varias fuentes para compilar una lista completa de lugares de producción para tus informes.",
    dimitraApps: "Aplicaciones Dimitra",
    addNew: "Agregar Nuevo",
    existingData: "Datos Existentes",
    manualDataEntry: "Entrada Manual de Datos",
    importFile: "Importar Archivo",
    connectedCoffee: "Café Conectado",
    connectedCacao: "Cacao Conectado",
    connectedFarmer: "Agricultor Conectado",
    manaulProductionPlace: "Entrada Manual de Lugares de Producción",
    farmerRegistrationId: "ID de Registro del Agricultor", 
    farmRegistrationId: "ID de Registro de la Finca",
    addProductionPlace: "Agregar Lugar de Producción",
    producerName: "Nombre del Productor",
    producerCountry: "País del Productor",
    totalArea: "Área Total (ha)",
    number: "Número",
    productionPlaceDesc: "Descripción del Lugar de Producción",
    area: "Área",
    type: "Tipo",
    actions: "Acciones",
    selectType: "Seleccionar Tipo",
    importProductionPlace: "Importar Lugar de Producción",
    downloadCSVFormat: "Descargar como Formato CSV",
    downloadXLSFormat: "Descargar Formato XLS",
    downloadGeoJsonFormat: "Descargar Formato GeoJSON",
    downloadXMLFormat: "Descargar Formato XML",
    downloadFileFormatTemplates: "Descargar Plantillas de Formato de Archivo",
    importantNote: "Nota Importante",
    pleaseProvideFollowing:
      "Por favor, proporcione el siguiente formato (GeoJSON y XML)",
    existingProductionPlaces: "Lugares de Producción Existentes",
    productionPlaceAndFarmID: "Lugar de Producción y ID de Finca",
    selectFileToUploadData: "Seleccionar archivo para cargar los datos",
    filterByDate: "Filtrar por fecha",
    dateOfRegister: "Fecha de registro",
    dateOfLastReport: "Fecha del último informe",
    clearAll: "Limpiar todo",
    addLocation: "Agregar ubicación",

    "pleaseCompleteBeforeProceedingToNext": "Por favor complete la sección de detalles del informe antes de proceder al siguiente paso.",
    "progressSavedSuccessMsg": "¡Progreso guardado con éxito!",
    "failedSavedProgress": "No se pudo guardar el progreso. Por favor, inténtelo de nuevo.",
    "failedToCreateReportDetails": "No se pudo crear ReportDetails. Por favor, inténtelo de nuevo.",
    "unExpectedErrorMsg": "Ocurrió un error inesperado. Por favor, inténtelo de nuevo.",
    "selectAssessment": "Seleccionar Evaluación",
    "confirmationPopup": "Ventana de Confirmación",
    "confirmationPopupMsg": "¿Está seguro de que desea descartar este informe? Confirmar esta acción resultará en la eliminación permanente.",
    "supplierNotRegisterContent": "El proveedor no está registrado. ¿Desea enviar una notificación al proveedor para que se una a la plataforma por correo electrónico?",

    "warningPopup": "Ventana de Advertencia",
    "warningPopupMsg": "¿Está seguro de que desea rechazar este informe? Nota: Los datos de este informe se guardarán después del rechazo en caso de que desee revisarlo más tarde.",
    "automatedDeforestationProgressText": "Verificación automatizada de deforestación de datos de geovalla e identificación de casos críticos",
    "someRiskWereIdentifiedText": "Se identificaron algunos riesgos en la siguiente granja, debe revisar la granja con los riesgos identificados y mitigarlos antes de pasar al siguiente paso.",
    "riskAssessmentAndMitigation": "Evaluación y Mitigación de Riesgos",
    "riskAssessmentStatus": "Estado de Evaluación de Riesgos",
    "riskAssessment": "Evaluación de Riesgos",
    "uploadRiskAssessment": "Subir Evaluación de Riesgos",
    uploadRiskAssessmentTT: "Acción para subir un documento de evaluación de riesgos.",
    "manualFillOutAssessment": "Rellenar evaluación manualmente",
    manualFillOutAssessmentTT: "Acción para completar un formulario de evaluación manualmente.",
    criteria : "Criterios (b, f y g)",
    "downloadAssessmentForm": "Descargar Formulario de Evaluación",
    "addSignature": "Agregar Firma",
    uploadImage: "Subir Imagen",
    "createNewDueDiligenceProgress": "Crear Nuevo Proceso de Debida Diligencia",
    "usageLimits": "Límites de Uso",
    "totalReports": "Total de Informes",
    "eudrDeforestationAssessments": "Evaluaciones de Deforestación EUDR",
    "totalAssessments": "Total de Evaluaciones",
    "listOfFarms": "Lista de Granjas",
    "perMonth": "Por Mes",
    "share": "Compartir",
    "viewReport": "Ver Informe",
    "viewReportSummary": "Ver resumen del informe",
    "copy": "Copiar",
    "copyAndCreateNew": "Copiar y Crear Nuevo",
    "listOfSupplier": "Lista de Proveedores",
    "addNewSupplier": "Agregar nuevos proveedores",
    "editSupplier": "Editar Proveedor",
    "supplierName": "Nombre del Proveedor",
    "listOfOperators": "Lista de Operadores",
    "addNewOperator": "Agregar nuevos operadores",
    "operatorName": "Nombre del Operador",
    "operators": "Operadores",
    "editOperator": "Editar Operador",
    "eoriNumber": "Número EORI",
    "enterEmailAddress": "Ingrese la dirección de correo electrónico",
    "enterFirstName": "Ingrese el nombre",
    "enterLastName": "Ingrese el apellido",
    "enterEORINumber": "Ingrese el número EORI",
    "myFarms": "Mis Granjas",
    "listOfProducers": "Lista de Productores",
    "producers": "Productores",
    "addNewProducer": "Agregar Nuevo Productor",
    "lastAssessment": "Última Evaluación",
    "noOfFarms": "Número de Granjas",
    "shipmentID": "ID de Envío",
    "shipmentList": "Lista de Envíos",
    "createShipment": "Crear nuevo envío",
    "noOfReports": "N.º de Informes",
    confirmation: "Confirmación",
    saveAndConfirmationMessage:"¿Estás seguro de que deseas guardar los cambios?",
    confirmDownload: "¿Desea descargar todos los archivos adjuntos en formato PDF?",

    selectProductionPlacesUsingLots: "Seleccione los lugares de producción utilizando lotes",
    SelectProductionPlacesUsingFarms: "Seleccione los lugares de producción utilizando granjas",

    areaForPointGeofence: "Área para geocerca circular",
    accordingToEUDRFarmsWithLessThan4HectaresDoNotRequireAPolygon: "Según EUDR, las granjas con menos de 4 hectáreas no requieren un polígono.",
    circularAreaEquivalent:  "En estos casos, utilizaremos un área circular equivalente al tamaño de la finca, con el punto GPS proporcionado como centro para verificar la deforestación. Cuando no se proporcione el tamaño de la finca, utilizaremos 4 hectáreas de forma predeterminada.", 
    ifTheFarmsAreSmallerPleaseEnterTheStandardSizeInTheFieldBelow: "Si las granjas son más pequeñas, ingrese el tamaño estándar en el campo a continuación.",
    defaultCircularGeofence: "Las granjas sin geocerca o sin información sobre su tamaño se asignarán una geocerca circular predeterminada de 4 hectáreas. Si el tamaño promedio de la finca es menor a 4 hectáreas, cambie el tamaño predeterminado haciendo clic en el botón 'Editar' a continuación.", 
    defaultAreaValueSpecified: "Las granjas sin geocerca o área recibirán el valor de área predeterminado especificado a continuación y se les asignará una geocerca circular con un radio circular." ,
    uploadFileBeingProcessed: "Sus archivos cargados se están procesando. Será redirigido a la página de lista de informes de debida diligencia para ver el estado.",
    processingLocations: "Procesando Ubicaciones",

    lotId: "ID de Lote",
    product:"Producto",
    qualityGade: "Grado de Calidad",
    processingDate: "Fecha de Procesamiento",   

    importProductionPlaceTT: "Permite a los usuarios importar datos de lugar de producción utilizando opciones de carga o descarga de archivos.",  
    internalReferenceNumberTT: "Un número de referencia o código utilizado internamente para organizar y gestionar informes de debida diligencia.",

    onlyShowFarmsWithIssues: "Mostrar solo granjas con problemas",

    analyzingStatus: "Analizando el Estado de Deforestación",
    readyToProceed: "Listo para Continuar",
    mitigationRequired: "Mitigación Requerida",
    viewSummary: "Ver Resumen",
    viewAssessment: "Ver Evaluación",
    disputes: "Disputas",
    manualRiskMitigation: "Mitigación Manual de Riesgo",
    veryHighProbability: "Muy Alta Probabilidad",
    highProbability: "Alta Probabilidad",
    mediumProbability: "Probabilidad Media",
    lowProbability: "Baja Probabilidad",
    veryLowProbability: "Muy Baja Probabilidad",
    zeroProbability: "Cero/Nula Probabilidad",
    manualMitigated: "Mitigado Manualmente",
    disputeDesc: "Haz clic en una de las disputas a continuación para ver más detalles.",
    geofenceColorCode: "Código de Color del Geofence:",
    noDisputeHaveSubmitted: "No se ha enviado ninguna disputa aún",
    disputeDetails: "Detalles de la Disputa",
    chooseDisputeReason: "Selecciona el Motivo de la Disputa",
    pleaseAttachDoc: "Por favor adjunta documentos/fotos para apoyar tu respuesta.",
    additionalNotes: "Notas Adicionales",
    aggrementStatement: "Entiendo que la tierra afectada no se utilizará para agricultura en los próximos años.",
    addGeofenceRadius: "Añadir Radio de Geofence",
    totalGeofenceRadius: "El Radio Total del Geofence es",
    resolutionHistory: "Historial de Resolución",
    proceed: "Continuar",
    wildFire: "Incendio Forestal",
    controlledFire: "Incendio Controlado",
    clearingForAgriculture: "Despeje para Agricultura y/o Ganadería",
    pestAndDiseases: "Plagas y Enfermedades",
    naturalChangesInCanopy: "Cambios Naturales en el Dosel (como caída de hojas estacional)",
    strongWinds: "Vientos Fuertes (como huracanes o tornados)",
    otherNaturalDisasters: "Otros Desastres Naturales",
    flooding: "Inundaciones",
    logging: "Tala de Bosques",
    infrastructure: "Infraestructura",
    urbanization: "Urbanización",
    landGrabbingOrPopulationPressure: "Despojo de Tierra, Agricultura de Subsistencia o Presión Poblacional",
    mining: "Minería",
    plantationForestBeforeDeadline: "Es un bosque de plantación o una tierra arborizada, pero los bosques primarios o los bosques naturalmente regenerados se convirtieron en bosques de plantación o en otras tierras arborizadas antes de la fecha límite (31 de diciembre de 2020)",
    convertedToPlantationForest: "Los bosques primarios o los bosques naturalmente regenerados se convirtieron en bosques de plantación o en otras tierras arborizadas",
    cultivatedAreaBeforeDeadline: "Es un área cultivada y no fue deforestada después de la fecha límite (31 de diciembre de 2020)",
    forestStillPreserved: "Hay un bosque en el área, pero no fue deforestado y todavía está preservado",
    downloadAsPDF: "Descargar como PDF",
    downloadAsJSON: "Descargar como JSON",
    downloadOptions: "Opciones de Descarga",
    productionPlacesHighDeforestationProbability: "Los lugares de producción tienen alta probabilidad de deforestación",
    geofenceHighDeforestationProbability: "El Geofence tiene alta probabilidad de deforestación",
    EUDRReferenceNumber: "Número de Referencia del EUDR",
    commonName: "Nombre Común",
    totalNoOfRiskAssessment: "Número Total de Evaluaciones de Riesgo",
    totalNoOfHighDeforestation: "Número Total de Fincas con Alta Probabilidad de Deforestación",
    totalNoOFDeforestationAssessments: "Número Total de Evaluaciones de Deforestación",
    totalNoOfFarms: "Número Total de Fincas",
    totalNoOfGeofencePoints: "Número Total de Puntos de Geofence",
    totalNoOfGeofencePolygons: "Número Total de Polígonos de Geofence",
    reportSummary: "Resumen del Informe",
    supplierData: "Datos del Proveedor",
    isoCode: "Código ISO",
    operatorData: "Datos del Operador",
    dueDiligenceReportStatus: "Estado del Informe de Diligencia Debida",
    declarationStatement: "Declaración del Operador",
    undoDelete: "Deshacer Eliminación",
    analyzingDeforestation: "Analizando la Deforestación",
    processingFarm: "Procesando Finca",
    supplierTT: "Selección de proveedores o fabricantes involucrados en la cadena de suministro.",
    pleaseSelectAtLeastOneItem: "Por favor selecciona al menos un elemento.",
    
    pleaseSelectAtLeastOneSource: "Por favor seleccione al menos una fuente.",
    invalidFileFormatPleaseUploadValidFile: "Formato de archivo no válido. Por favor cargue un archivo .xml, .kml o .geojson.",
    pleaseUploadAValidFile: "Por favor cargue un archivo válido.",
    fileUploadedDuccessfully: "¡Archivo cargado con éxito!",
    anErrorOccured: "Ocurrió un error.",
    successfullyUpdatedDefaultFarmArea: "Área de granja predeterminada actualizada con éxito.",
    pleaseAddProductionPlacesData: "Por favor agregue los datos de los lugares de producción.",
    failedToFetchSettings: "No se pueden obtener las configuraciones. Por favor, revise sus configuraciones o contacte con soporte si el problema persiste.",
    updatedDueDiligenceReport: "Informe de diligencia debida actualizado.",
    updatedDueDiligenceStatus: "El estado de la Diligencia Debida se ha actualizado correctamente.",
    failedToWriteDeforestationDataToBlockchain: "Error al escribir los datos de deforestación en la cadena de bloques, por favor intente nuevamente.",

    mutiStepHeadingLable: "Cree una nueva etapa para cada sub-título",
    multiStepQuestion1: "Cree un nuevo paso despues de",
    questions: "preguntas",
    questionsInfo: "Cantidad de preguntas en cada etapa de una evaluación de varios pasos.",
    countryIsRequired: "País es requerido", 
    

    dueDiligenceReportsInfo: "Documentación detallada que resume los hallazgos y resultados del proceso de debida diligencia. Estos informes proporcionan información sobre la evaluación realizada, incluidos los riesgos identificados, el estado de cumplimiento y las recomendaciones para la mitigación o mejora.",
    listOfFarmsTT: "Una visualización completa de las granjas, incluida información como la ubicación de producción, el nombre del productor, el país de operación, el área de tierra en hectáreas, el tipo de actividades agrícolas, evaluaciones relacionadas con la deforestación y evaluaciones de los riesgos potenciales asociados con las operaciones de la granja.",
    existingProductionPlacesTT: "Muestra una lista de lugares de producción existentes junto con detalles como el nombre del productor, país, área, tipo y estado de evaluación.",
    loadingPleaseWait: "Cargando... Por favor espere",
    analyzingDesc: "Tus granjas están siendo sometidas a un Análisis Automatizado de Deforestación. Serás redirigido a la página de la lista de Informes de Diligencia Debida para ver el estado.",
    successfullyGeneratedEUDRDeforestationStatus: "Se generó correctamente el estado de deforestación de EUDR.",
    riskAssessmentAndMitigationTT: "Identificar riesgos potenciales e implementar estrategias para minimizar su impacto o probabilidad de ocurrencia. Incluye evaluar peligros, analizar sus posibles consecuencias y desarrollar planes para abordarlos o mitigarlos de manera efectiva.",
    
    eudrRefNoTT: "Un identificador único asignado a cada informe de diligencia debida, que facilita el seguimiento y la verificación de cumplimiento dentro del marco del Reglamento de Deforestación de la Unión Europea (EUDR)." ,

    operatorDataTT: "Información sobre el operador.",
    supplierDataTT: "Información sobre el proveedor.",
    reportSummaryTT: "Descripción breve del informe.",
    totalNoOfGeofencePolygon: "Número Total de Polígonos de Geocerca",
    totalNoOfGeofencePolygonTT: "Conteo total de polígonos de geocerca.",
    totalNoOfGeofencePoint: "Número Total de Puntos de Geocerca",
    totalNoOfGeofencePointTT: "Conteo total de puntos de geocerca.",
    totalNoOfFarmsTT: "Conteo total de granjas.",
    totalAreaFinalReport: "Área Total (ha)",
    totalNoOfDeforestationTT: "Conteo total de evaluaciones de deforestación.",
    totalNoOfHighDeforestationTT: "Conteo total de granjas con alta deforestación.",
    totalNoOfRiskAssessments: "Número Total de Evaluaciones de Riesgo",
    totalNoOfRiskAssessmentsTT: "Conteo total de evaluaciones de riesgo.",
    productDetail: "Detalles del Producto",
    productDetailTT: "Información sobre el producto.",
    productTT: "Nombre del producto. Se refiere a un artículo tangible o mercancía producida, fabricada o comercializada por una empresa u organización, a menudo categorizada según su tipo, características o propósito.",
    productDescription: "Descripción del Producto",
    productDescriptionTT: "Proporciona una explicación o resumen textual de las características, funciones o atributos de un producto, con el objetivo de informar a los usuarios o clientes sobre su naturaleza o funcionalidad.",
    netMass: "Masa Neta",
    netMassTT: "Indica el peso de un producto o artículo, normalmente excluyendo el peso del embalaje u otros materiales asociados, a menudo expresado en unidades de masa como kilogramos o libras.",
    volume: "Volumen",
    volumeTT: "Se refiere a la cantidad de espacio que ocupa un producto o sustancia, generalmente medido en unidades cúbicas como metros cúbicos o pies cúbicos, utilizado para cuantificar la capacidad o cantidad en el espacio tridimensional.",
    scientificName: "Nombre Científico",
    scientificNameTT: "Nombre taxonómico de un organismo que consta del género y la especie, por ejemplo, Coffea Arabica, Theobroma cacao L.",
    commonNameTT: "Un nombre basado en el lenguaje común de la vida cotidiana, por ejemplo, Cacao, Café.",

    successfullyUploadedToTheBlockchain: "¡Éxito! El Informe de Diligencia Debida de EUDR se ha subido con éxito a la Blockchain.",
    complianceRiskWarning: "Advertencia de Riesgo de Cumplimiento",
    issueIdentifiedOnFarms: "Se han identificado problemas en algunas granjas que necesitan atención antes de proceder al siguiente paso. Puede elegir abordar estos problemas ahora o continuar al siguiente paso y resolverlos más tarde.",
    blockchainDescs: [
      'Subiendo informe a blockchain, por favor espera...',
      'Su informe de Diligencia Debida se está subiendo a blockchain. Será redirigido a la página de lista de Informes de Diligencia Debida para ver el estado.'
    ],
    reportDownloadedSuccessfully: "¡Éxito! El Informe de Diligencia Debida de EUDR se ha descargado con éxito.",
    operatorDecleration: "Declaración del Operador",
    supplierDecleration: "Declaración del Proveedor",
    fRinternalReferenceNumberTT: "Un número de referencia interno es un identificador único asignado a un informe de diligencia debida dentro del sistema.",
    deleteProductionPlaceData: "Eliminar Datos del Lugar de Producción",
    areYouSureYouWantToContinueThisAction: "¿Estás seguro de que deseas continuar con esta acción?",
    noAssessment: "Sin evaluación",
    
    uploadingToBlockchain: "Cargando informe en la blockchain, por favor, espere...",
    beingUploadToBlockChain: "Su informe de Diligencia Debida se está cargando en la blockchain. Serás redirigido a la página de lista de Informes de Diligencia Debida para ver el estado.",
    uploading: "Cargando",
    attachFile: "Adjuntar Archivo",
    close: "Cerrar",
    status: "Estado",
    lotID: "ID de Lote",
    noOfFarm: "No. de Granjas",
    origin: "Origen",
    selectUsingLots: "Seleccionar Lugares de Producción Usando Lotes",
    productionPlaceUsingFarms: "Seleccionar Lugares de Producción Usando Granjas",
    searchFarmName: "Buscar nombre de granja",
    viewLocation: "Ver Geolocalización",
  
    selectStatus: "Seleccionar Estado",
    netMassKG: "Masa Neta (kg)",
    volumeM3: "Volumen (m³)",
    volumeM: "Volumen",
    areaInHA: "Área (ha)",
    eudrUploadedToBlockChain: "¡Éxito! El Informe de Diligencia Debida EUDR se ha cargado con éxito en la Blockchain.",
    viewDeforestationAssessment: "Ver Evaluación de Deforestación",
    viewDeforestationCertificate: "Ver Certificado de Deforestación",
    selectCountries: "Seleccionar Países",
    writingToBlockchain: "Escribiendo en la Blockchain",
    

    compilanceRiskWarning: "Advertencia de Riesgo de Cumplimiento",
    operatorDeclerationTT: "Declaración de declaración del operador.",
    supplierDeclerationTT: "Declaración de declaración del proveedor.",




    cattle: "Ganado",
    cocoa: "Cacao",
    "coffee": "Café",
    "wood": "Madera",
    "soya": "Soja",
    "rubber": "Caucho",
    oilPlam: "Palma de aceite",
    
    subProduct1: "0102 21 , 0102 29 Bovinos vivos",
    subProduct2: "0201 Carne de bovino, fresca o refrigerada",
    subProduct3: "0202 Carne de bovino, congelada",
    subProduct4: "0206 10 Despojos comestibles de bovino, frescos o refrigerados",
    subProduct5: "0206 22 Hígados comestibles de bovino, congelados",
    subProduct6: "0206 29 Despojos comestibles de bovino (excepto lenguas e hígados), congelados",
    subProduct7: "1602 50 Las demás preparaciones y conservas de carne, despojos y sangre de bovino",
    subProduct8: "4101 Cueros y pieles, en bruto, de ganado vacuno (frescos o salados, secos, encalados, piquelados o conservados de otro modo, pero sin curtir, apergaminar ni preparar de otra forma), incluso depilados o divididos",
    subProduct9: "4104 Cueros y pieles de vacuno depilados, curtidos o crust, incluso divididos, pero sin otra preparación",
    subProduct10: "4107 Cueros de vacuno preparados después del curtido o del secado, incluidos los cueros apergaminados, depilados, incluso divididos, excepto los cueros de la partida 4114",
    subProduct11: "1801 Cacao en grano, entero o partido, crudo o tostado",
    subProduct12: "1802 Cáscaras, cáscaras, pieles y demás desperdicios de cacao",
    subProduct13: "1803 Pasta de cacao, incluso desgrasada",
    subProduct14: "1804 Manteca, grasa y aceite de cacao",
    subProduct15: "1805 Cacao en polvo, sin adición de azúcar ni otro edulcorante",
    subProduct16: "1806 Chocolate y demás preparaciones alimenticias que contengan cacao.",
    subProduct17: "0901 Café, incluso tostado o descafeinado; cáscaras y pieles de café; sucedáneos del café que contienen café en cualquier proporción",
    subProduct18: "1207 10 Nueces y pepitas de palma",
    subProduct19: "1511 Aceite de palma y sus fracciones, incluso refinado, pero sin modificar químicamente",
    subProduct20: "1513 21 Aceites de palmiste y de babasú, en bruto, y sus fracciones, incluso refinados, pero sin modificar químicamente",
    subProduct21: "1513 29 Aceites de palmiste y de babasú y sus fracciones, incluso refinados, pero sin modificar químicamente (excepto el petróleo crudo)",
    subProduct22: "2306 60 Tortas y demás residuos sólidos de nueces o almendras de palma, incluso molidos o en pellets, resultantes de la extracción de grasas o aceites de nueces o almendras de palma",
    subProduct23: "2905 45 Glicerol, con una pureza igual o superior al 95 % (calculada sobre el peso del producto seco)",
    subProduct24: "2915 70 Ácido palmítico, ácido esteárico, sus sales y ésteres",
    subProduct25: "2915 90 Ácidos monocarboxílicos acíclicos saturados, sus anhídridos, halogenuros, peróxidos y peroxiácidos; sus derivados halogenados, sulfonados, nitrados o nitrosados ​​(excepto ácido fórmico, ácido acético, ácido mono, di o tricloroacético, ácido propiónico, ácido butanoico, ácido pentanoico, ácido palmítico, ácido esteárico, sus sales y ésteres y anhídrido acético)",
    subProduct26: "3823 11 Ácido esteárico, industrial",
    subProduct27: "3823 12 Ácido oleico, industrial",
    subProduct28: "3823 19 Ácidos grasos monocarboxílicos industriales; Aceites ácidos procedentes del refinado (excepto ácido esteárico, ácido oleico y ácidos grasos de tall oil)",
    subProduct29: "3823 70 Alcoholes grasos industriales",
    subProduct30: "4001 Caucho natural, balata, gutapercha, guayule, chicle y gomas naturales similares, en formas primarias o en placas, láminas o tiras.",
    subProduct31: "4005 Caucho compuesto, sin vulcanizar, en formas primarias o en placas, hojas o tiras",
    subProduct32: "4006 Caucho sin vulcanizar en otras formas (por ejemplo, varillas, tubos y perfiles) y artículos (por ejemplo, discos y anillos)",
    subProduct33: "4007 Hilos y cordones de caucho vulcanizado",
    subProduct34: "4008 Placas, láminas, tiras, varillas y perfiles, de caucho vulcanizado sin endurecer",
    subProduct35: "4010 Correas o correas transportadoras o de transmisión, de caucho vulcanizado",
    subProduct36: "4011 Neumáticos nuevos de caucho",
    subProduct37: "4012 Llantas neumáticas de caucho recauchutadas o usadas; neumáticos macizos o acolchados, bandas de rodadura y faldones para neumáticos, de caucho",
    subProduct38: "4013 Cámaras de aire, de caucho",
    subProduct39: "4015 Prendas y complementos (incluidos guantes, manoplas y manoplas), para todos los usos, de caucho vulcanizado sin endurecer",
    subProduct40: "4016 Las demás manufacturas de caucho vulcanizado sin endurecer, no expresadas en otra parte del capítulo 40",
    subProduct41: "4017 Caucho duro (por ejemplo, ebonita) en todas sus formas, incluidos desperdicios y desechos; manufacturas de caucho endurecido",
    subProduct42: "1201 Habas de soja, incluso quebrantadas",
    subProduct43: "1208 10 Harina y sémola de soja",
    subProduct44: "1507 Aceite de soja y sus fracciones, incluso refinado, pero sin modificar químicamente",
    subProduct45: "2304 Tortas y demás residuos sólidos de la extracción del aceite de soja, incluso triturados o en pellets.",
    subProduct46: "4401 Leña para combustible, en rollizos, tochos, ramitas, leños o formas similares; madera en astillas o partículas; aserrín, desperdicios y desechos de madera, incluso aglomerados en leños, briquetas, pellets o formas similares",
    subProduct47: "4402 Carbón vegetal (incluido el carbón vegetal de cáscaras o de nueces), incluso aglomerado",
    subProduct48: "4403 Madera en bruto, incluso descortezada o alburada, o escuadrada",
    subProduct49: "4404 Aro de madera; postes divididos; pilotes, estacas y estacas de madera, puntiagudas pero sin aserrar longitudinalmente; palos de madera, desbastados pero sin tornear, curvar ni trabajar de otro modo, aptos para la fabricación de bastones, paraguas, mangos de herramientas o artículos similares; madera astillada y similares",
    subProduct50: "4405 Lana de madera; harina de madera",
    subProduct51: "4406 Traviesas (traviesas) de madera para vías férreas o tranvías",
    subProduct52: "4407 Madera aserrada o desbastada longitudinalmente, cortada o desenrollada, incluso cepillada, lijada o unida por los extremos, de espesor superior a 6 mm",
    subProduct53: "4408 Hojas para enchapado (incluidas las obtenidas por corte de madera laminada), para contrachapado o para otras maderas laminadas similares y demás maderas, aserradas longitudinalmente, cortadas o desenrolladas, incluso cepilladas, lijadas, empalmadas o unidas por los extremos, de espesor no superior a 6 mm",
    subProduct54: "4409 Madera (incluidas las tiras y frisos para parqué, sin ensamblar) conformada de forma continua (machihembrada, ranurada, rebajada, achaflanada, en V, rebordeada, moldeada, redondeada o similares) por cualquiera de sus bordes, extremos o caras, incluso no cepillado, lijado ni ensamblado en los extremos",
    subProduct55: "4410 Tableros de partículas, tableros de virutas orientadas (OSB) y tableros similares (por ejemplo, waferboards) de madera u otras materias leñosas, incluso aglomerados con resinas u otras sustancias aglutinantes orgánicas.",
    subProduct56: "4411 Tableros de fibras de madera u otras materias leñosas, incluso aglutinados con resinas u otras sustancias orgánicas",
    subProduct57: "4412 Madera contrachapada, tableros enchapados y maderas similares laminadas",
    subProduct58: "4413 Madera densificada, en bloques, placas, tiras o perfiles",
    subProduct59: "4414 Marcos de madera para cuadros, fotografías, espejos u objetos similares",
    subProduct60: "4415 Cajones, cajas, jaulas, tambores y envases similares, de madera; tambores para cables de madera; paletas, paletas caja y demás plataformas de carga, de madera;",
    subProduct61: "collarines para paletas de madera (sin incluir el material de embalaje utilizado exclusivamente como material de embalaje para soportar, proteger o transportar otro producto comercializado)",
    subProduct62: "4416 Barriles, toneles, tinas, tinas y demás manufacturas de tonelería y sus partes, de madera, incluidas las duelas",
    subProduct63: "4417 Herramientas, cuerpos de herramientas, mangos de herramientas, cuerpos y mangos de escobas o cepillos, de madera; hormas y hormas para botas o calzado, de madera",
    subProduct64: "4418 Ebanistería y carpintería de madera para la construcción, incluidos paneles de madera celular, paneles para pisos ensamblados, tejas y tejas",
    subProduct65: "4419 Vajilla y artículos de cocina, de madera.",
    subProduct66: "4420 Marquetería y taracea de madera; cofres y estuches para joyería o cuchillería y artículos similares, de madera; estatuillas y demás objetos de adorno, de madera; artículos de mobiliario de madera no comprendidos en el capítulo 94",
    subProduct67: "4421 Otras manufacturas de madera",
    subProduct68: "Pasta y papel de los capítulos 47 y 48 de la Nomenclatura Combinada, con excepción de los productos a base de bambú y los productos recuperados (desperdicios y desechos)",
    subProduct69: "49 Libros impresos, periódicos, fotografías y demás productos de la industria gráfica, manuscritos, textos mecanografiados y planos, de papel.",
    subProduct70: "9401 Asientos (excepto los de la partida 9402), incluso transformables en cama, y ​​sus partes, de madera",
    subProduct71: "9403 30 , 9403 40 , 9403 50 , 9403 60 y 9403 91 Muebles de madera y sus partes",
    subProduct72: "9406 10 Construcciones prefabricadas de madera",
    totalNoOfDeforestation: "Número Total de Deforestación",
    
    blockchainVerification: "Verificación de Blockchain",
    scanQrBlockchain: "Escanee este código QR para ver el Informe de diligencia debida del EUDR en blockchain.",
    downloadQrCode: "Descargar código QR",
    eudrPublicReport: "Informe público de diligencia debida de Dimitra EUDR",
    scanQrEudr: "Escanee este código QR para ver el Informe de diligencia debida del EUDR en la web pública.",
    viewReportForPublic: "Haga clic aquí para ver el informe para el público",
  
    riskAssessmentNotApproved: "los lugares de producción no están aprobados.",
    viewReportOnBlockChain: "Haga clic aquí para ver el informe en la cadena de bloques",


    declarationMissing: "Declaración Ausente",
    removeRiskFarms: "ELIMINAR FINCAS DE RIESGO",
    disregardRiskDocument: "IGNORAR FINCAS DE RIESGO",
    attachRiskMitigationDocumentForNonCompliantFarms: "ADJUNTAR DOCUMENTO DE MITIGACIÓN DE RIESGO PARA TODAS LAS FINCAS NO CUMPLIDAS",
    uploadMitigationDocumentForNonCompliantFarms: `Subir un documento de mitigación de riesgos para todas las fincas no cumplidas cambiará el estado de las fincas con "Mitigación Requerida" a "Mitigado Manualmente".`,
    disregardFarmWithIssuesTitle:"Ignorar Fincas",
    disregardFarmWithIssuesMessage: "Al seleccionar 'Ignorar', las fincas con estado de evaluación de riesgo 'Mitigación Requerida' se ignorarán y se eliminarán de este informe. Por favor, confirme que desea continuar.",
    removeRiskFarmTitle: "Eliminar Fincas",
    removeRiskFarmMessage: "Al seleccionar 'Eliminar', las fincas con estado de evaluación de riesgo 'Mitigación Requerida' se eliminarán de este informe. Por favor, confirme que desea continuar.",
      
    fileName: "Nombre del archivo",
    dateAndTime: "Fecha y hora",
    downloadProgressStatus: "Estado del progreso de la descarga",
    downloadHistory: "Historial de descargas",
    downloaded: "Descargado",
    inprogress: "En progreso",
    failed: "Fallido",
    showAllDownloads: "Mostrar todas las descargas",
    inProgress: "En progreso",
    downloadCompleted: "Descarga completada",
    downloadFailed: "Descarga fallida",
    errorDeletingItem: "No se pudo eliminar el elemento. Por favor, inténtelo de nuevo más tarde.",
    anErrorOccuredPlsTryAgain: "Algo salió mal. Por favor, inténtelo de nuevo.",
    invalidData: "Los datos proporcionados no son válidos. Por favor, verifique e inténtelo de nuevo.",
    fileIsReady: "El archivo está listo para usar",
    invalidFilePathOrUrl: "La ruta o URL del archivo no es válida.",
    errorDownloadingFile: "Hubo un problema al descargar el archivo. Por favor, inténtelo de nuevo.",
    downloadInitiated: "Descarga iniciada",
    beingDownloaded: "se está descargando. Tiempo estimado",

    multiStepSurveyDetails: "Según el número de preguntas en un paso, todas las preguntas de la encuesta se agruparán y se mostrarán en pasos. Sin embargo, esta configuración solo está disponible antes de agregar preguntas o subtítulos. Una vez que se agregue una pregunta o un subtítulo, la configuración de múltiples pasos se desactivará automáticamente. Por favor, elimine cualquier pregunta o subtítulo para volver a habilitar esta opción.",
    estimatedTime: "Tiempo estimado",
    tryAgain: "Intentar de nuevo",
  },

  diligenceGuide: {
    downloadPdfManual: "Descargar Manual en PDF",
    watchDemoVideo: "Ver Video Demostrativo",
    viewManualOnWeb: "Ver Manual en la Web",
  },
  welcomeScreenDiligenceGuide: {
    title: "Tu Centro Esencial de Guías",
    description: `Explora nuestra página de Guías de Ayuda del Sistema de Diligencia Debida de EUDR
      para recursos esenciales, incluidos manuales en PDF, tutoriales en video y asistencia
      basada en la web. Empodérate para navegar por la plataforma de manera eficiente
      y optimiza tu flujo de trabajo.`,
    continueToTheDueDiligenceSystem: "Continuar al Sistema de Diligencia Debida",

  },
  assessmentStatus:{
    riskAssessmentSummary: "Resumen de Evaluación de Riesgos",
    riskAssessmentSummaryTT: "Resumen de Evaluación de Riesgos",
    totalNoOfFarms: "Número Total de Granjas",
    assessmentsCompleted: "Evaluaciones Completadas",
    assessmentsPending: "Evaluaciones Pendientes",
    requiredMitigation: "Mitigación Requerida",
  }
}